import * as React from 'react';
import ArrowCounterClockwiseOutlined from './arrow-counter-clockwise-outlined';
import ArrowCounterClockwiseFilled from './arrow-counter-clockwise-filled';
import type { IconCombinedProps } from './types';
const ArrowCounterClockwiseCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowCounterClockwiseFilled ref={ref} {...rest} />;
  }
  return <ArrowCounterClockwiseOutlined ref={ref} {...rest} />;
});
export default ArrowCounterClockwiseCombined;